export default async (bricksBuilder, PAYMENT_ID, store) => {
  const settings = {
    initialization: {
      paymentId: PAYMENT_ID, // id do pagamento a ser mostrado
    },
    callbacks: {
      onReady: () => {
        /*
          Callback chamado quando o Brick estiver pronto.
          Aqui você pode ocultar loadings do seu site, por exemplo.
        */
       store.dispatch('ViewPaymentMp', { comp: 'PaymentBrick', status: false })
       window.paymentBrickController.unmount()
      },
      onError: (error) => {
        // callback chamado para todos os casos de erro do Brick
        console.error(error)
      },
    },
  }
  window.statusScreenBrickController = await bricksBuilder.create(
    'statusScreen',
    'statusScreenBrick_container',
    settings,
  )
}
